import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ChipComponent } from '@rogers/cdk/chip';
import { IconComponent } from '@rogers/cdk/icon';
import { LabelComponent } from '@rogers/cdk/label';
import { ModalModule } from '@rogers/cdk/modal';
import { AccountSelectorModalComponent } from './account-selector-modal.component';

@NgModule({
  declarations: [AccountSelectorModalComponent],
  imports: [CommonModule, ChipComponent, IconComponent, LabelComponent, ModalModule, TranslateModule],
  exports: [AccountSelectorModalComponent],
})
export class AccountSelectorModalModule {}
